import { render, staticRenderFns } from "./AdvisorCoreNavGroup.vue?vue&type=template&id=6d73adf2&scoped=true&"
import script from "./AdvisorCoreNavGroup.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreNavGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d73adf2",
  null
  
)

export default component.exports